module.exports = __webpack_public_path__ + "static/img/hands2.c433147b.jpg";